module.exports = __webpack_public_path__ + "img/right.dbc4f43f.png";